export const mockData = {
  campaigns: [
    {
      id: 1,
      title: "Race Towards March 2027: Endometriosis Awareness Month",
      description: "Calling specialist gynaecologists to volunteer for pro bono consultations (minimum 10 patients) and surgeries during March 2027. Donations needed to cover hospital costs, theatre costs, medicine, equipment, anesthetists, and theatre staff for life-changing procedures.",
      goalAmount: 2500000,
      currentAmount: 25000,
      image: "https://customer-assets.emergentagent.com/job_disease-fighters/artifacts/mk08ftd3_istockphoto-1275708051-612x612.jpg",
      category: "Awareness Campaign",
      featured: true,
      deadline: "March 2027"
    }
  ],
  donationTiers: [
    {
      type: "Donor",
      title: "Individual Donor",
      description: "Support ongoing research with a one-time or monthly contribution",
      benefits: [
        "Quarterly impact reports",
        "Donor recognition on website",
        "Tax-deductible receipts",
        "Email updates on research progress"
      ],
      suggestedAmounts: [500, 1000, 2500, 5000]
    },
    {
      type: "Sponsor",
      title: "Research Sponsor",
      description: "Sponsor specific research projects and make a lasting impact",
      benefits: [
        "All Donor benefits",
        "Named recognition in research publications",
        "Invitation to research symposiums",
        "Detailed project outcome reports",
        "Advisory board consultation opportunities"
      ],
      suggestedAmounts: [10000, 25000, 50000, 100000]
    },
    {
      type: "Partner",
      title: "Strategic Partner",
      description: "Partner with us to drive systemic change in chronic pain medical coverage",
      benefits: [
        "All Sponsor benefits",
        "Co-branding opportunities",
        "Board representation",
        "Custom partnership programs",
        "Joint advocacy initiatives",
        "Media and PR collaboration"
      ],
      customContact: true
    }
  ]
};
